<div class="wrapper {{classToggle}} {{classSidebarMini}}">
  <app-sidebar (logout)="onLogout()" (minifiedSidebar)="onMinifiedSidebar()"></app-sidebar>
  <div class="main-panel">
    <app-navbar  (logout)="onLogout()" (toggle)="onToggle()"></app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
